import { applyI18n, t } from '../i18n';
import { iconImg } from './icons';

export function formatFilesConflictStatus(
  conflicts: Array<{ originalPath: string; resolvedPath: string }>,
): string {
  if (conflicts.length === 0) {
    return '';
  }

  const [first] = conflicts;
  const fileName = first.resolvedPath.split('/').pop() ?? first.resolvedPath;
  return t('files.owner.conflictSavedAs', { path: fileName });
}

export function filesConflictBannerMarkup(id: string): string {
  return `
    <div class="warning-panel files-folder-conflict" id="${id}" hidden role="status">
      <span class="warning-panel__icon files-folder-conflict__icon"></span>
      <p class="files-folder-conflict__message"></p>
      <button type="button" class="icon-button files-folder-conflict__dismiss" data-i18n-aria-label="common.close" data-i18n-title="common.close"></button>
    </div>
  `;
}

export function bindFilesConflictBanner(banner: HTMLElement, onDismiss: () => void): void {
  const icon = banner.querySelector('.files-folder-conflict__icon');
  if (icon && !icon.querySelector('.icon-wrap')) {
    icon.append(iconImg('warning', 20));
  }

  const dismiss = banner.querySelector('.files-folder-conflict__dismiss') as HTMLButtonElement | null;
  if (dismiss && !dismiss.dataset.bound) {
    dismiss.dataset.bound = '1';
    dismiss.append(iconImg('x', 16));
    dismiss.addEventListener('click', onDismiss);
  }

  applyI18n(banner);
}

export function showFilesConflictBanner(banner: HTMLElement | null, message: string): void {
  if (!banner) {
    return;
  }
  const messageEl = banner.querySelector('.files-folder-conflict__message');
  if (messageEl) {
    messageEl.textContent = message;
  }
  banner.hidden = false;
}

export function hideFilesConflictBanner(banner: HTMLElement | null): void {
  if (!banner) {
    return;
  }
  const messageEl = banner.querySelector('.files-folder-conflict__message');
  if (messageEl) {
    messageEl.textContent = '';
  }
  banner.hidden = true;
}
